// extracted by mini-css-extract-plugin
export default {"main":"ArtistSuggestionsItemEditorFooter_main__lktEA","buttonsArea":"ArtistSuggestionsItemEditorFooter_buttonsArea__2JP82"};